/**
 * Form ayrılma koruması.
 * Fatura/teklif/sipariş/irsaliye formları doluyken kullanıcı sekme veya menü ile
 * sayfadan ayrılmak isterse onay sorulabilmesi için global "form dolu" bayrağı.
 * Formlar içerik durumuna göre bayrağı günceller; TabBar/Sidebar ayrılmadan önce okur.
 */

let formDirty = false;

export function setFormDirty(dirty: boolean): void {
  formDirty = dirty;
}

export function isFormDirty(): boolean {
  return formDirty;
}
